<div class="modal-header modalHeaderBlack" >
  <h6 class="modal-title">Document Viewer</h6>
    <mat-icon  (click)="closeView()" matTooltip="{{ 'AddInternalNotes.close' | translate }}"
      >clear</mat-icon>
</div>
  
  <div *ngIf="!isImage" class="center" id="pdfContainer" style="height: 73vh"></div>
  <img  *ngIf="isImage" [src]="imageSrc" class="img">
